<template>
    <fragment>
        <section class="flat-slider style1 clearfix bg-image">
            <div class="rev_slider_wrapper fullwidthbanner-container">
                <div id="rev-slider1" class="rev_slider fullwidthabanner">
                    <ul>
                        <!-- Slide 1 -->
                        <li data-transition="random">
                            <!-- Main Image -->
                            <div class="overlay"></div>

                            <!-- Layers -->
                        </li>
                    </ul>
                </div>
            </div>
            <div class="apply-admission">
                <div class="card bs-turq pb-5 pt-3">
                    <div class="apply-admission-inner">
                        <h2 class="title text-center mt-3">
                            <span>Password Reset Success</span>
                        </h2>
                        <div class="caption text-center">
                            Please check your email inbox for further instructions on how to reset your account
                            <br />
                            <br />
                            Be sure to check your SPAM folder if you do not receive a message within the next 10 minutes.
                        </div>
                    </div>
                </div>
            </div>
        </section><!-- flat-slider -->
    </fragment>
</template>
<style scoped>
    .bs-turq {
        box-shadow: #42c1c4 0 0 20px 1px;
    }

    .bg-image {
        background-color: #282D69 ;
        max-width: 100%;
        height: 91vh;
        margin-top: -16px;
        top: 100px!important;
    }

    .apply-admission {
        position: absolute;
        top: 25%;
        margin: 0;
        left: 15%;
        width: 70%;
        z-index: 100;
    }

    .apply-admission-wrap {
        padding-top: 20px !important;
        padding-bottom: 20px !important;
    }

    .register-link {
        color: white;
        text-decoration: underline;
        font-size: 20px;
    }

    .not-valid {
        border-color: rgb(255, 95, 96);
        border-width: 3px;
    }

    .alert-danger {
        background-color: rgb(255, 95, 96);
        border-color: rgb(255, 95, 96);
        color: white;
    }
</style>
<script>
    export default {
        name: 'ForgotSuccess',
        components: {
        },
        data: function () {
            return {
           
            }
        },
        methods: {
           
        },
        mounted: function () {
            this.$store.commit("breadCrumbs", null);
        }
    };
</script>
